export default __webpack_public_path__ + "static/17-7b00d6554ebe41aec58b3b23d60634c0.webp";